import { DraftError } from '@/types';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { StoreState } from '@/redux/types';

export function getConfigurationErrors(
  state: StoreState,
  configurationId: number
): DraftError | undefined {
  return getDraft(state).validation.errors[configurationId];
}
